import { IClassroomResource } from "../../classrooms";
import { IUserResource } from "../../users";
import { createApiQueryHook, IApiQueryFunction, IPaginateable, mapPagination } from "../../utils/api";
import { RelationalFilter, mapRelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { IValidationList } from "../types";

export interface IValidationListQueryParameters extends IPaginateable {
    filters?: {
        learner: RelationalFilter<IUserResource>;
        classroom?: RelationalFilter<IClassroomResource>;
    };
}

export type IValidationListQueryResult = IValidationList;

const mapFilters = (filters: IValidationListQueryParameters["filters"]) => {
    const { learner, classroom } = filters ?? {};
    return {
        "learner.uuid": mapRelationalFilter(learner),
        "classroom.uuid": mapRelationalFilter(classroom),
    };
};

export const validationListQuery: IApiQueryFunction<IValidationListQueryParameters> = ({ pagination, filters }) => {
    return {
        method: "GET",
        url: `/validations${serialize(
            {
                ...mapPagination(pagination),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useValidationListQuery = createApiQueryHook<IValidationListQueryParameters, IValidationListQueryResult>(
    validationListQuery,
);
